import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const corporateReportingService = {
  getIncidents,
  getHazards,
};

function getIncidents(params) {
  return axios
    .get(`${apiEndpoint.corporateReporting}/incidents`, {
      params,
      headers: authHeader(),
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

function getHazards(propertyId) {
  return axios
    .get(`${apiEndpoint.corporateReporting}/hazards`, {
      params: { property_id: propertyId },
      headers: authHeader(),
    })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}
